var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "single-coupon-footer",
      class: { "live-streaming": _vm.isLiveStreamAvailable }
    },
    [
      _c(
        "div",
        { staticClass: "time" },
        [
          _c("sgp-tag", {
            attrs: {
              markets: _vm.ksPreProcessEven(_vm.event).markets,
              isLive: 1,
              filterMarkets: "some",
              isForCoupon: "couponEvent"
            }
          }),
          _vm._v(" "),
          _vm.isFlashBettingEvent && _vm.isFlashBettingEnabled
            ? _c("div", { staticClass: "flash-betting-event" }, [
                _c("span", { staticClass: "flash-betting-indicator" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "live-box" }, [
            _vm._v(_vm._s(_vm.$t("Sports.Live")))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "live-time" }, [
            _vm._v(_vm._s(_vm.activePeriodName))
          ]),
          _vm._v(" "),
          ["FOOTBALL", "SOCCER", "BASKETBALL", "HANDBALL"].indexOf(
            _vm.event.idfosporttype
          ) > -1
            ? [
                !_vm.matchTimer &&
                _vm.event.istimeractive &&
                _vm.event.matchcurrenttimeinmins
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("formatMinutesWithSeconds")(
                            _vm.event.matchcurrenttimeinmins
                          )
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.matchTimer
                  ? _c("match-time-display", {
                      attrs: { timer: _vm.matchTimer }
                    })
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.additionalFound && _vm.phraseToHighlight
        ? _c(
            "span",
            { staticClass: "additional-found" },
            [
              _c(
                "text-highlight",
                { attrs: { queries: _vm.phraseToHighlight } },
                [_vm._v(_vm._s(" " + _vm.additionalFound))]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLiveStreamAvailable
        ? _c(
            "div",
            {
              staticClass: "live-stream",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.goToEvent(_vm.event)
                }
              }
            },
            [
              _c("v-icon", [_vm._v("play_arrow")]),
              _vm._v(" "),
              _c("span", [_vm._v("Watch Live")])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.brandLayout === "generic" ||
      _vm.brandKey === "sb" ||
      _vm.brandKey === "mav" ||
      _vm.brandKey === "qcasino"
        ? _c(
            "div",
            {
              staticClass: "more-markets",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.goToEvent(_vm.event)
                }
              }
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("Sports.Markets")))]),
              _vm._v(" "),
              _c("v-icon", [_vm._v("add")])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-521bdd72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-521bdd72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/live/liveCouponEventFooter.vue
// module id = null
// module chunks = 